<template>
  <div>
    <Transition name="slide-fade">
      <q-card
        v-if="props.rightDrawerOpen"
        class="drawer-modal text-black"
        :class="classTitulo"
      >
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center justify-between">
            <div class="row items-center">
              <q-icon
                style="cursor: pointer"
                name="close"
                class="q-mr-md"
                size="22px"
                @click="fecharModal()"
              />
              <span style="font-size: 16px">
                <span>
                  <span class="texto-titulo-modal" :class="classTitulo">
                    {{ nomeModal }}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </div>
        <q-scroll-area
          v-if="tipoModal == 'scroll'"
          style="width: 100%; height: 85%"
        >
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 80%"
          >
            <div class="q-px-md text-weight-bold">
              <slot name="conteudo-modal"></slot>
            </div>
            <div class="row q-px-md q-mt-xs">
              <slot name="botao-modal"></slot>
            </div>
          </div>
        </q-scroll-area>
        <div
          v-else
          class="column justify-between no-wrap"
          style="width: 100%; height: 88%"
        >
          <div class="q-px-md text-weight-bold">
            <slot name="conteudo-modal"></slot>
          </div>
          <div class="row q-px-md q-mt-md">
            <slot name="botao-modal"></slot>
          </div>
        </div>
      </q-card>
    </Transition>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

const props = defineProps({
  rightDrawerOpen: Boolean,
  nomeModal: String,
  tipoModal: String,
  classTitulo: String,
});

const emits = defineEmits(["fecharModal"]);

const fecharModal = () => {
  emits("fecharModal");
};
</script>

<style scoped>
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 600px;
  position: fixed;
  top: 106px;
  height: 85%;
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow-y: scroll;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 85%;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
}
</style>
